export type {
  DrawerFooterProps as NavDrawerFooterProps,
  DrawerFooterSlots as NavDrawerFooterSlots,
  DrawerFooterState as NavDrawerFooterState,
} from '../../Drawer/DrawerFooter/DrawerFooter.types';
